import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { isDevelopment } from '../config/dev';
import { invalidateBusinessIdeaCache } from '@orbit/shared/cache';
import { useAuth } from '@orbit/shared/auth';
import { useBusinessIdea } from '../hooks/useBusinessIdea';

const CacheResetButton: React.FC = () => {
  const { user } = useAuth();
  const { refetch } = useBusinessIdea();

  if (!isDevelopment()) {
    return null;
  }

  const handleCacheReset = () => {
    if (user) {
      invalidateBusinessIdeaCache(user.id);
      refetch(); // Trigger a fresh fetch to show the effect

      // Show a brief visual feedback
      const button = document.getElementById('cache-reset-button');
      if (button) {
        button.style.backgroundColor = '#10b981';
        setTimeout(() => {
          button.style.backgroundColor = '#3b82f6';
        }, 500);
      }
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 23, sm: 75 },
        right: { xs: 16, sm: 20 },
        zIndex: 9999,
        transform: 'translateX(-120px)', // Position to the left of DevIndicator
      }}
    >
      <Tooltip title="Reset business idea cache (development only)" arrow>
        <Chip
          id="cache-reset-button"
          label="🗑️ CACHE"
          size="small"
          onClick={handleCacheReset}
          sx={{
            backgroundColor: '#3b82f6',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '0.75rem',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#2563eb',
            },
            transition: 'background-color 0.2s ease',
          }}
        />
      </Tooltip>
    </Box>
  );
};

export default CacheResetButton;
